// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5928":"806e5c167e4da16d","9121":"e8ca149104bb227e"}[chunkId] + ".js";
};